import React, { useEffect, useState } from 'react';
import fetchAdminAreas from '../api/adminAreas';
import { AdminArea } from '../types';
import AdminAreaListing from './adminAreaListing';
import { StateAreasLoadingSkeleton } from './stateAreasLoadingSkeleton';
import { LoadError } from './loadError';

interface Props {
    code?: string
}

const ClimbingAreasByState = (props: Props) => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [adminAreas, setAdminAreas] = useState<AdminArea[]>([]);
    // Bumped by "Try again" to refetch
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        setIsLoaded(false);
        setError(null);
        fetchAdminAreas(true)
        .then(
          (adminAreas) => {
            setIsLoaded(true);
            setAdminAreas(adminAreas);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        );
    }, [attempt]);

    // Show error
    if (error) {
        return (
          <LoadError
            title="We couldn’t load the list of areas"
            message="The server didn’t respond. Please try again in a moment."
            onRetry={() => setAttempt((n) => n + 1)}
          />
        );
    // Show loading
    } else if (!isLoaded) {
      return <StateAreasLoadingSkeleton />;
    // Show results
    } else {
      const filteredAdminAreas = props.code ? adminAreas.filter(adminArea => adminArea.code === props.code) : adminAreas
      return <AdminAreaListing adminAreas={filteredAdminAreas} />
    }

};

export default ClimbingAreasByState;